<template >
  <v-card
    height="100%"
    class="mx-auto"
    style="background-color: #0e355c"
    elevation="5"
  >
    <v-card-title
      style="margin: 0 0 0 25%; margin-top: -1%; margin-bottom: 2%"
      class="name"
      >{{ getName(guide.name) }}</v-card-title
    >
    <v-row style="width: 100%">
      <object
        style="margin-top: 8%; min-width: 800px"
        scrolling="no"
        width="75%"
        v-bind:id="'fileFrame' + guide.id"
        v-if="GeneralType(guide) && !pdfImage"
      ></object>
      <img
        v-if="typeXlsx(guide)"
        width="30%"
        style="margin-right: 30%; margin-left: 10%; margin-top: 8%"
        src="@/assets/xlsx_icon.png"
      />
      <img
        v-if="typeDocx(guide)"
        width="30%"
        style="margin-right: 30%; margin-left: 10%; margin-top: 8%"
        src="@/assets/docx_icon.png"
      />
      <img
        v-if="pdfImage"
        width="30%"
        style="margin-right: 30%; margin-left: 10%; margin-top: 8%"
        src="@/assets/pdf_icon.png"
      />
      <v-col style="width: 20%; padding-top: 10%">
        <v-row>
          <v-card-subtitle class="inf" style="font-weight: bold">
            Descripción: </v-card-subtitle
          ><v-card-subtitle class="inf" style="width: 50%">
            {{ guide.description }}
          </v-card-subtitle>
        </v-row>

        <v-row>
          <v-card-subtitle class="inf" style="font-weight: bold">
            Fecha: </v-card-subtitle
          ><v-card-subtitle class="inf">
            {{ filteredDate(guide.date) }}
          </v-card-subtitle>
        </v-row>

        <v-btn
          color="#E1251B"
          style="
            color: white;
            margin-top: 8%;
            min-width: 150px;
            min-height: 100px;
          "
          height="10%"
          width="50%"
          @click="downloadFile(guide)"
        >
          DESCARGAR</v-btn
        >
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { getGuideFile } from "@/utils/apiRequest";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      pdfImage: false,
    };
  },

  props: {
    guide: Object,
  },
  methods: {
    getName(name) {
      if (name == undefined) {
        return name;
      }
      let parts = name.split(".");
      return parts[0];
    },
    filteredDate(dateString) {
      let date = new Date(dateString);
      return date.toLocaleString();
    },
    async downloadFile(item) {
      let response = await getGuideFile(item.id);
      FileSaver.saveAs(response.data, item.name);
    },
    typeXlsx(guide) {
      if (guide.type == "xlsx") {
        return true;
      }

      return false;
    },
    typeDocx(guide) {
      if (guide.type == "docx") {
        return true;
      }
      return false;
    },
    GeneralType(guide) {
      if (this.typeDocx(guide) || this.typeXlsx(guide)) {
        return false;
      }

      return true;
    },

    pdfNotLoaded(guide) {
      if (guide.type != "pdf") {
        return false;
      }

      const frame = document.getElementById("fileFrame" + this.guide.id);
      if (frame == undefined) {
        return true;
      }

      if (frame.src == "") {
        return true;
      }

      return false;
    },
  },

  async mounted() {
    if (this.typeXlsx(this.guide.type) || this.typeDocx(this.guide.type)) {
      return;
    }
    let response = await getGuideFile(this.guide.id);
    if (!response) {
      return;
    }
    if (response.status != 200) {
      return;
    }
    const frame = document.getElementById("fileFrame" + this.guide.id);

    var data_url = await window.URL.createObjectURL(response.data);

    frame.data = data_url;
    frame.type = response.data.type;
  },
};
</script>
<style scoped>
iframe {
  overflow: hidden;
  margin-left: 25px;
  overflow: scroll;
  transform: scale(0.5);
  transform-origin: top center;
}

.inf {
  font-size: Larger;
  color: white;
}

.name {
  font-size: 60px;
  font-weight: bolder;
  color: white;
}

object {
  max-width: 80%;
  width: 80%;
}
</style>